import React, { useState, useEffect } from 'react';
import InputRange, { InputRangeProps, Range } from 'react-input-range';

import './RadiusSlider.scss';

interface Props
	extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'>,
		Partial<InputRangeProps> {
	minRadius: number;
	maxRadius: number;
	disabled?: boolean;
	current: Range;
}

const RadiusSlider = ({
	className,
	minRadius,
	maxRadius,
	current,
	disabled,
	onChangeComplete
}: Props): JSX.Element => {
	const [radius, setRadius] = useState<Range | number>({
		min: current.min,
		max: current.max
	});

	// Synchronize state with updated current prop
	useEffect(() => {
		setRadius({ min: current.min, max: current.max });
	}, [current]);

	return (
		<div
			data-disabled={disabled}
			className={`radius-slider${className ? ` ${className}` : ''} ${disabled ? 'disabled' : ''}`}
		>
			<InputRange
				maxValue={maxRadius}
				minValue={minRadius}
				value={radius as number}
				onChange={val => setRadius(val)}
				onChangeComplete={onChangeComplete}
			/>
			<div className="flex">
				<span className="radius-slider--text text-base">
					Min: <span>{(radius as Range).min} mi</span>
				</span>
				<span className="radius-slider--text ml-auto text-base">
					Max: <span className="">{(radius as Range).max} mi</span>
				</span>
			</div>
		</div>
	);
};

export default RadiusSlider;
